import axios from 'axios';

import { extractData, logError } from '@/api/ApiHelpers';

import type { LonLat, RectangleItem } from '@/components/map/types/mapFeatureTypes';
import type {
	CcmCnetInfoRequest,
	CcmCnetListResponse,
	CcmCnetRealDataResponse,
	CcmGenerateRequest,
	CcmGenerateResponse,
	CcmLoadCnetResponse,
	CcmSaveAndApplyRequest,
	CcmSaveResponse,
	CcmSelectedGridpoint,
} from '@/components/map/cnetConstructorMode/types/ccmTypes';


const buildCnetInfos = (
	cnetNumbers: number[] | null,
	cnetDates: string[] | null,
): CcmCnetInfoRequest[] | null => {
	if (cnetNumbers == null || cnetDates == null) {
		return null;
	}
	const infos: CcmCnetInfoRequest[] = [];
	cnetNumbers.forEach((cnetNumber, index) => {
		const cnetDate = cnetDates[index];
		if (cnetDate !== undefined) {
			infos.push({ cnet_number: cnetNumber, cnet_date: cnetDate });
		}
	});
	return infos;
};


const cNetListGetList = (
	excludeCurrent: number,
	handler: (data: CcmCnetListResponse) => void,
): void => {
	axios.get('/gridpoints/get_cnet_list/', { params: { exclude_current: excludeCurrent } })
		.then(extractData(handler)).catch(logError);
};


const cNetConstructorLoadData = (
	id: number,
	handler: (data: CcmLoadCnetResponse) => void,
): void => {
	axios.get('/gridpoints/load_cnet_data/', { params: { id } })
		.then(extractData(handler)).catch(logError);
};


const cNetConstructorGenerateData = (
	boundRectangles: RectangleItem[],
	anchorPoint: LonLat | null,
	step: number,
	handler: (data: CcmGenerateResponse) => void,
): void => {
	axios.post('/gridpoints/generate/', {
		bound_rectangles: boundRectangles,
		anchor_point: anchorPoint,
		step,
	} satisfies CcmGenerateRequest).then(extractData(handler)).catch(logError);
};


const cNetConstructorSaveAndApply = (
	id: number,
	boundRectangles: RectangleItem[],
	anchorPoint: LonLat | null,
	step: number,
	title: string,
	listOfGrids: CcmSelectedGridpoint[][],
	subNetworkId: number | null,
	cnetNumbers: number[] | null,
	cnetDates: string[] | null,
	doSave: boolean,
	handler: (data: CcmSaveResponse) => void,
): void => {
	axios.post('/gridpoints/save_and_apply/', {
		source_id: id,
		bound_rectangles: boundRectangles,
		anchor_point: anchorPoint,
		step,
		title,
		selected_gridpoints: listOfGrids,
		sub_network_id: subNetworkId,
		cnet_infos: buildCnetInfos(cnetNumbers, cnetDates),
		do_save: doSave,
	} satisfies CcmSaveAndApplyRequest).then(extractData(handler)).catch(logError);
};


const cNetRealDataGet = (
	id: number,
	handler: (data: CcmCnetRealDataResponse) => void,
): void => {
	axios.get('/gridpoints/get_cnet_real_data/', { params: { id } })
		.then(extractData(handler)).catch(logError);
};


export default {
	cNetListGetList,
	cNetConstructorLoadData,
	cNetConstructorGenerateData,
	cNetConstructorSaveAndApply,
	cNetRealDataGet,
};
